import Vue from 'vue';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
Vue.use(VueGoogleAutocomplete, {
  load: {
    key: `${process.env.VUE_APP_GOOGLE_API_KEY}`,
  },
});

Vue.component('vue-google-autocomplete', VueGoogleAutocomplete);
